import { createAction } from 'typesafe-actions';
import { Websocket } from './Websocket.types';

export const initWebsocket = createAction('WEBSOCKETS | INIT')();
export const closeWebsocket = createAction('WEBSOCKETS | CLOSE_CLIENT')();
export const recieveMessage = createAction('WEBSOCKETS | RECIEVE_MESSAGE')<Websocket.Message>();
